import { createReducer, on } from '@ngrx/store';
import * as MasterLettersActions from '../actions/sa-master-status-view.actions';
import { ServiceErrorDetails } from '../../create-request/models/shared/ServiceErrorDetails';
import { MsvLetterAttributes } from '../../create-request/models/Standing-Authorizations';
import { JsonApiListWrap } from '../../shared/models/JsonApiWrap';
import { MasterStatusViewActions } from '../../create-request/actions';

export const masterLettersKey = 'masterLetters'

export interface State extends MasterLettersState { }

export interface MasterLettersState {
  isBookmarkFilterOn: boolean;
  letters: MsvLetterAttributes[];
 }

export const initialMasterLettersState: State = {
  letters: [],
  isBookmarkFilterOn: false
}

export const initialState: MasterLettersState = {
  letters: [],
  isBookmarkFilterOn: false
};

export const masterLettersReducer = createReducer(
  initialState,
  on(MasterLettersActions.callLetters, (state) => {
    return {
    ...state,
    isBookmarkFilterOn: false
    }
  }),
  on(MasterLettersActions.callLettersSuccess,
    MasterLettersActions.callBookmarkedAccountsSuccess,
     (state, response) => {
    return {
      ...state,
      letters: [...mapLetters(response)],
    }
  }),
  on(MasterLettersActions.callLettersFailure, (state, { error }) => {
    return {
      ...state,
      letters: []
    }
  }),
  on(MasterLettersActions.callLettersEmptyResponse, (state) => {
    return {
      ...state,
      letters: []
    }
  }),
  on(MasterLettersActions.getBookmarkedAccounts, (state) => {
    return {
      ...state,
      isBookmarkFilterOn: true

    }
  })
);

function mapLetters(lettersResponse: JsonApiListWrap<MsvLetterAttributes>): MsvLetterAttributes[] {
  return lettersResponse.data.map((letter) => {
    return {
      formattedAccountNumber: letter.attributes.formattedAccountNumber,
      accountName: letter.attributes.accountName,
      accountName2: letter.attributes.accountName2,
      accountName3: letter.attributes.accountName3,
      registrationType: letter.attributes.registrationType,
      thirdPartyIndValue: letter.attributes.thirdPartyIndValue,
      typeDescription: letter.attributes.typeDescription,
      toForStatusAndRecurring: letter.attributes.toForStatusAndRecurring,
      toForSloa: letter.attributes.toForSloa,
      isViewable: letter.attributes.isViewable,
      mediaTypeCD: letter.attributes.mediaTypeCD,
      accountNumber: letter.attributes.accountNumber,
      txnCd: letter.attributes.txnCd,
      isThirdPartyInd: letter.attributes.isThirdPartyInd,
      bundledSloaIn: letter.attributes.bundledSloaIn,
      outIn: letter.attributes.outIn,
      isExpandReporting: letter.attributes.isExpandReporting,
      isExpandReportingJournal: letter.attributes.isExpandReportingJournal,
      isExpandReportingWire: letter.attributes.isExpandReportingWire,
      isExpandReportingCheck: letter.attributes.isExpandReportingCheck,
      faMasterAcct: letter.attributes.faMasterAcct,
      cashieringRqstId: letter.attributes.cashieringRqstId,
      cashieringRqstSecondId: letter.attributes.cashieringRqstSecondId,
      statusCd: letter.attributes.statusCd,
      rejectDate: letter.attributes.rejectDate,
      reqTypeCd: letter.attributes.reqTypeCd,
      pfaRole: letter.attributes.pfaRole,
      disbursementAuthorization: letter.attributes.disbursementAuthorization,
      totalAcctBalance: letter.attributes.totalAcctBalance,
      isTooManyRecords: letter.attributes.isTooManyRecords
    };
  });
}
